import Http from "@/utils/request.js"
import UploadOss from "@/utils/uploadOss.js"
import UploadFile from "@/utils/upload.js"

//banner
export function Banner(position){
	return Http.request({
		url: `/user/banner/getBanner`,
		method: 'post',
		data:{
			position
		}
	})
}

//获取地址
export function Address(data){
	return Http.request({
		url: `/user/base/getAddress`,
		method: 'post',
		data
	})
}

//地址逆编码
export function Geocode(latitude, longitude){
	return Http.request({
		url: `/base/address/getAddressInfo`,
		method: 'post',
		data:{
			level: 2,
			latitude,
			longitude
		}
	})
}

//获取当前热门城市
export function HotCity(){
	return Http.request({
		url: `/base/address/getHotCity`,
		method: 'post',
	})
}

//协议
export function Agreement(type){
	return Http.request({
		url: `/user/agress/getAgree`,
		method: 'post',
		data:{
			type
		}
	})
}

//发送验证码
export function SendSMS(data){
	return Http.request({
		url: `/user/base/sendSms`,
		method: 'post',
		data
	})
}

//发送邮箱验证码
export function SendMailCode(data){
	return Http.request({
		url: `/user/base/sendMailCode`,
		method: 'post',
		data
	})
}

//获取语言列表
export function GetLanguageData(key){
	return Http.request({
		url: `/user/base/getLanguage`,
		method: 'get',
		data:{
			key
		}
	})
}

//上传
export function Upload(filePath,formData = {}, taskFn){
	// return UploadOss(filePath, formData.type, taskFn);
	return UploadFile(filePath, taskFn);
}

//平台基本信息 
export function PlatformInfo(){
	return Http.request({
		url: `/base/commom/info`,
		method: 'post'
	})
}